import { Menu } from "primereact/menu";
import { DashboardReportOptions } from "./DashboardReportOptions";
import { DashboardTabModel, OldDashboardTabModel } from "./DashboardTab";

export type DashboardBase = {
  id: number;
  title: string;
  companyShared: boolean;
  sortWeight: number;
  implementation: Implementation;
  modifiedAt: string;
  modifiedBy: string | null;
};

export type DashboardSimpleDto = DashboardBase & {
  reportVersion: string | null;
  companyRef: string;
  companyTitle: string;
  assignedUsers: string[];
  hiddenForUsers: string[];
  modifiedByDisplay: string | null;
};

export type CreateDashboardRequest = {
  title: string;
  companyRef: string;
  implementation: Implementation;
};

export interface Dashboard extends OldDashboard, DashboardBase {
  iconClass: string;
  dashboardTabsJs: Array<DashboardTabModel>;
  tabsDisplay: TabsDisplay;
  company: number;
  showTabNavigation: boolean;
  reportOptions: DashboardReportOptions;
  tabGroups?: TabGroup[];
}

export interface DashboardRequest extends Dashboard {
  overwrite?: boolean;
}

export type DashboardEditStatus = {
  message: string | null;
  isEdited: boolean;
  otherEditors: string[];
};

export type TabGroup = {
  uuid: string;
  title: string;
  isTabPlaceholder?: boolean;
};

export enum TabsDisplay {
  ROWS = "ROWS",
  DROPDOWN = "DROPDOWN",
  DROPDOWN_ROWS = "DROPDOWN_ROWS",
  SUB_TAB_DROPDOWN = "SUB_TAB_DROPDOWN",
}

interface OldDashboard {
  dashboardTabs: Array<OldDashboardTabModel>;
}

export type DashboardHistoryDto = {
  id: number;
  dashboardId: number;
  dashboardTabs: OldDashboardTabModel[];
  dashboardTabsJs: DashboardTabModel[];
  tabGroups: TabGroup[];
  reportOptions: DashboardReportOptions;
  changeBy: string;
  changeByCompanyRef: string;
  changeByCompanyTitle: string;
  changeOn: string;
};

export type PaginatedResponse<T> = {
  items: T[];
  pageInfo: OffsetPageInfo;
};

export type OffsetPageInfo = {
  skip: number;
  take: number;
  total: number;
};

export type DashboardPaginatedRequest = {
  dashboardId: number;
  skip?: number;
  take?: number;
};

export const IMPLEMENTATION = {
  STANDARD: "Standard",
  REPORTS_JS: "Reports",
  REPORTS_JS_V2: "Reports V2",
  JS: "JavaScript",
} as const;

export type Implementation = keyof typeof IMPLEMENTATION;

export type DashboardTabOptionComponentProps = {
  isMobile: boolean;
  menuRef: React.RefObject<Menu | null>;
  tabId: number;
  dashboard: Dashboard;
};
